import { AxiosResponse } from "axios";

import client from "../client";

import { postSignUpMicrosoftConfig } from "./postSignUpMicrosoftConfig";

import { PostRegisterResponseData } from "../postRegister/types";
import { PostSignUpMicrosoftPayload } from "./types";

const postSignUpMicrosoft = async (
  data?: PostSignUpMicrosoftPayload
): Promise<AxiosResponse<PostRegisterResponseData>> =>
  await client({ ...postSignUpMicrosoftConfig, data: { provider: "microsoft", ...data } });

export default { postSignUpMicrosoft };
